import { post } from "jquery";
import axios from "../api/axios";
import config from '../config/configJS';

export function getEnvironmentsforUser() { 
    return postData('GetDocsEnv', {})
        .then((data) => data.Data);
}

export function getAllEnvironments() {
    return postData('GetAllDocsEnv', {})
    .then((data) => data.Data);
}

export function getExtractionEnabled() {
    return postData('GetExtractionEnabled', {}).then((data) => data.Data);
}

// Stav modelov pre offline spracovanie PDF: { Ready, Downloading, Error, Dir }
export function getOfflineModelsStatus() {
    return postData('GetOfflineModelsStatus', {}).then((data) => data.Data);
}

export function setExtractionEnabled(enabled) {
    return postData('SetExtractionEnabled', { "Enabled": enabled }).then((data) => data.Data);
}

// Stránkovaný zoznam dokumentov priečinka: { Files, Total, Page, Pages, PageSize, StatusCounts }
export function getFilesForEnvironment(id, { page = 1, pageSize = 100, search = '', status = null } = {}) {
    return postData('GetDocsEnvById', { "Id": id, "Page": page, "PageSize": pageSize, "Search": search, "Status": status })
        .then((data) => data.Data);
}

export function getEnvironmentById(id) {
    return postData('GetDocsEnvWithTeamsById', { "Id": id })
        .then((data) => data.Data); 
}

export function deleteEnvironment(id) {
    return postData('DeleteDocsEnv', {
        "Id": id
    }).then((data => data.Data));
}

export function createEnvironment(env) {
    return postData('CreateDocsEnv', {
        "Name": env.Name,
        "FolderName": env.FolderName,
        "RoleId": env.RoleId,
        "TeamIds": env.TeamIds,
        "Type": env.Type,
        "DocIntelligence": env.DocIntelligence,
        "ImgProcessing": env.ImgProcessing,
        "Description": env.Description,
        "DescriptionLocked": env.DescriptionLocked
    }).then((data) => data);
}

export function updateEnvironment(env) {
    return postData('UpdateDocsEnv', {
        "Id": env.id,
        "Name" : env.name,
        "TeamIds" : env.teamIds,
        "DocIntelligence": env.docIntelligence,
        "ImgProcessing": env.imgProcessing,
        "Description": env.description,
        "DescriptionLocked": env.descriptionLocked
    }).then((data) => data.Data);
}

// Návrh popisu obsahu priečinka od AI (neuloží sa — správca ho uloží s priečinkom): celá odpoveď (Status, Data)
export function generateDescription(id) {
    return postData('GenerateDocsEnvDescription', { "Id": id });
}

export function deleteFiles(ids) {
    // [].concat normalizuje: jedno id -> [id], pole id -> [...] (hromadné mazanie)
    return postData('FilesToBeDeleted', {
        "ids" : [].concat(ids)
    }).then((data) => data.Data);
}

export function getTeams() {
    return postData('GetTeams', {})
    .then((data) => data.Data);
}



function postData(intent, data) { 
    var promise = new Promise(function (resolve, reject) { 
      axios
        .post(config.endPoint + '/api/millai/prompt', 
            JSON.stringify({ Intent: intent, data: data }), {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            withCredentials: true,
        })
        .then((response) => {       
            let obj = JSON.parse(response.data);
            resolve(obj);
        })
        .catch((error) => {
            console.log(error);
            reject(error);
        });
    });

    return promise;
}


